<template>
  <div>
    <div class="save-site">
      <img
        v-if="icono == ''"
        :src="ObtenerLogoSeguridad"
        alt="logo"
        class="save-site"
      />
    </div>

    <div class="icono-header d-flex flex-row justify-center align-center">
      <img v-if="icono == ''" :src="ObtenerLogo" alt="logo" class="logo-cmv" />
      <v-icon v-else size="70" color="white">{{ 'mdi-' + icono }} </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconoHeaderPuntual',
  data: () => ({
    //
  }),
  computed: {
    ObtenerLogo() {
      return require('@/assets/images/logo_solo.png')
    },
    ObtenerLogoSeguridad() {
      return require('@/assets/images/SSL.png')
    },
  },
  props: {
    icono: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.icono-header {
  .logo-cmv {
    width: 80px;
    height: auto;
  }
}
.save-site {
  text-align: end;
  margin-right: 5%;
  img {
    width: 80px;
    height: auto;
  }
}
</style>
